export default __webpack_public_path__ + "static/media/pc-bg-header.64af67f5.webp";